export { default } from './Promote';
